import React from "react";
import { Link } from "react-router-dom";
import { StorageHelpers } from "../../../core/Helpers";
import { setToken } from "../../../redux/slices/authSlice";
import { setClinicName } from "../../../redux/slices/clinicSlice";
import { SmsValidator } from "../../../components";
import InputMask from "react-input-mask";
import "./cliniclogin.scss";
import GRecaptcha from "../../../components/GRecaptcha";
import useClinicLogin from "./useClinicLogin";

const ClinicLogin = () => {
  const {
    form,
    formik,
    dispatch,
    navigate,
    setShowSmsValidationModal,
    showSmsValidationModal,
    isPerson,
    isLoading,
    branches,
    branchesLoading,
  } = useClinicLogin();
  return (
    <div className="main-login-area flex flex-col animate__animated animate__fadeIn">
      <div className="duration-300 w-fit md:w-[500px] text-xl font-semibold p-4  flex flex-col items-center">
        <Link to="/login">
          <div className="w-full justify-center flex flex-col gap-2 mb-4 items-center ">
            <img className="w-96" src="/assets/images/logo.png" alt="Logo" />
          </div>
        </Link>
        <div className="col-span-1 drop-shadow-md rounded-md mt-1 p-4 w-full">
          <div className="flex font-bold justify-center mt-4 ">
            <div {...form.legal}>Tüzel</div>
            <div {...form.person}>Şahıs</div>
          </div>
          <div className="flex text-center justify-center text-sm mt-2">
            <span>{isPerson ? "Şahıs" : "Tüzel"} olarak giriş yapıyorsunuz. </span>
          </div>
          <div className="text-center text-xs mt-2">
            Hasvet Medikal'de kayıtlı olmuş olduğunuz fatura bilgileriniz
            <span className="text-red-500"> (Vergi no veya Tc Kimlik)</span> ve
            <span className="text-red-500"> telefon (gsm)</span> numaranız ile giriş yapabilirsiniz.
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-6 flex flex-col font-normal">
              <input {...form.idNo} />
            </div>
            <span className="text-xs flex text-red-600 duration-300">{formik.touched.idNo && formik.errors.idNo}</span>
            <div className="mt-6   flex flex-col font-normal">
              <InputMask {...form.gsm} />
            </div>
            <span className="text-xs flex text-red-600 duration-300">{formik.touched.gsm && formik.errors.gsm}</span>
            <div className="mt-6 flex flex-col font-normal">
              <select {...form.idBranch}>
                {branchesLoading ? (
                  <option value="">Yükleniyor...</option>
                ) : (
                  branches?.map((branch) => (
                    <option key={branch.idBranch} value={branch.idBranch}>
                      {branch.branchName}
                    </option>
                  ))
                )}
              </select>
            </div>
            <GRecaptcha {...form.gRecaptcha} />
            <div className="flex mt-4 items-center">
              <button {...form.login}>{isLoading ? "Giriş Yapılıyor..." : "Giriş Yap"}</button>
            </div>
          </form>
          <Link to="/register">
            <div className="flex justify-center text-sm mt-4 text-gray-500 hover:text-gray-700 duration-200 cursor-pointer">
              Hasvet Medikal'de kaydınız yok ise kayıt olmak için tıklayınız.{" "}
            </div>
          </Link>
        </div>

        <SmsValidator
          isOpen={showSmsValidationModal}
          onClose={() => setShowSmsValidationModal(false)}
          onVerify={(data) => {
            StorageHelpers.setAuthToken(data.token);
            dispatch(setToken(data.token));
            dispatch(setClinicName(data.name));
            navigate("/request-list");
          }}
          formikData={formik.values}
        />
      </div>
    </div>
  );
};

export default ClinicLogin;
